import { extendObservable } from 'mobx'
import groupBy from 'lodash/groupBy'
import map from 'lodash/map'
import mergeWith from 'lodash/mergeWith'
import pick from 'lodash/pick'

import { emailApi } from '@atheneum/api'

class EplEmailStore {
  constructor (growlStore) {
    extendObservable(this, {
      growlStore,
      loading: null,
      statistics: [],
      totals: null,
      eplEmails: []
    })
  }

  getEplEmails (eplId) {
    this.loading = true
    emailApi
      .getByEpl(eplId)
      .then(eplEmails => {
        // Display one entry for each email.recipient
        eplEmails = eplEmails.reduce((acc, email) => {
          return acc.concat(email.recipients.map(er => ({ ...email, ...er })))
        }, [])
        this.eplEmails.replace(eplEmails)
        this.loading = false
      })
      .catch(this.growlStore.showError)
  }

  loadStatistics (projectId) {
    this.loading = true
    emailApi
      .getProjectStatistics(projectId)
      .then(result => {
        let statistics = groupBy(result, 'employeeId')
        statistics = map(statistics, eplStatistics => ({
          employeeFullName: eplStatistics[0].employeeFullName,
          eplStatistics,
          ...this.getTotals(eplStatistics)
        }))
        this.statistics.replace(statistics)
        this.totals = this.getTotals(statistics)
        this.loading = false
      })
      .catch(this.growlStore.showError)
  }

  getTotals (statistics) {
    let totals = {
      recipients: 0,
      sent: 0,
      delivered: 0,
      opened: 0,
      clicked: 0,
      applied: 0,
      declined: 0,
      submitted: 0,
      interviewed: 0
    }

    totals = statistics.reduce((acc, data) => {
      data = pick(data, Object.keys(totals))
      return mergeWith(acc, data, (accValue, dataValue) => accValue + dataValue)
    }, totals)
    return totals
  }
}

export default EplEmailStore
